import { render, staticRenderFns } from "./TheHeaderLinks.vue?vue&type=template&id=4ae7a5d4&scoped=true&"
import script from "./TheHeaderLinks.vue?vue&type=script&lang=js&"
export * from "./TheHeaderLinks.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderLinks.vue?vue&type=style&index=0&id=4ae7a5d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae7a5d4",
  null
  
)

export default component.exports